import React, { FC } from "react";
import Icon from "@ht/shared/fonts/deos-pis/arsi";
import AudioAnalyser from "../visualizer/AudioAnalyzer";
interface IProps {
  name?: string
  srcobj?: any
}
const DummyCard: FC<IProps> = ({ name, srcobj }) => {
  return (
    <div
      className="h-[100%] min-h-[90px] w-full bg-gray-200 rounded-lg flex flex-col justify-center items-center gap-[10px]">

      <div className="flex flex-col justify-center items-center  gap-1 w-[150px] h[150px]">
        <Icon className="w-[36px] h-[36px]"></Icon>
        {srcobj && <AudioAnalyser audio={srcobj}></AudioAnalyser>}
      </div>

    </div>
  );
}

export default DummyCard;
